<template>
  <div>
    <v-dialog v-model="showInternal" max-width="1500px">
      <v-card height="75vh" style="overflow: scroll">
        <v-card-title>Features For Account</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-simple-table dense class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Flag Name</th>
                      <th>Value</th>
                      <th>Source</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="feat in featuresList" :key="feat.name">
                      <td>{{ feat.name }}</td>
                      <td>{{ feat.value }}</td>
                      <td>{{ feat.source }}</td>
                      <td>
                        <v-btn icon @click="removeFeatureFlag(feat.name)"><v-icon>mdi-delete</v-icon></v-btn>
                        <v-btn icon @click="editFlag(feat.name)"><v-icon>mdi-pencil</v-icon></v-btn>
                        <v-btn icon v-if="isBooleanFlag(feat.name)" @click="flipFeatureFlag(feat)"
                          ><v-icon>mdi-swap-horizontal</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-form ref="scrollToMe" v-model="isValid">
            <v-row>
              <v-col cols="12" md="4">
                <v-select v-model="form.featureFlag" label="Flag" :items="allFeatureNames" @change="editFlag(form.featureFlag)" />
              </v-col>
              <v-col cols="12" md="5">
                <ordered-item-select
                  v-if="isArrayFlag(form.featureFlag)"
                  :model.sync="form.value"
                  :all-options="featureMap.get(form.featureFlag).options"
                />
                <v-select v-if="isBooleanFlag(form.featureFlag)" v-model="form.value" :items="[true, false]" />
                <v-text-field v-if="isStringFlag(form.featureFlag)" v-model="form.value" label="Value" />
                <json-object-field
                    label="Value"
                    v-if="isMapStringStringFlag(form.featureFlag)"
                    :model.sync="form.value"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="form.source" label="Source" :items="['ACCOUNT', 'BROKERAGE']" />
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col>
                <v-btn :disabled="!isValid" small @click="upsertFeature">Upsert</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col>
              <h3>Full Feature List</h3>
              <v-simple-table dense class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Flag Name</th>
                      <th>Description</th>
                      <th>Type</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="feat in allFeatures" :key="feat.name">
                      <td>{{ feat.name }}</td>
                      <td>{{ feat.description }}</td>
                      <td>{{ feat.type }}</td>
                      <td>
                        <v-btn icon @click="editFlag(feat.name)"><v-icon>mdi-pencil</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import OrderedItemSelect from '@/components/form/OrderedItemSelect'
import JsonObjectField from "@/components/form/JsonObjectField.vue";

export default {
  name: 'FeatureDialog',
  components: { OrderedItemSelect, JsonObjectField },
  props: {
    showDialog: { type: Boolean, required: false },
    features: { type: Object, required: true },
  },
  async mounted() {
    await this.getFullFeatureList()
  },
  data: () => ({
    isValid: undefined,
    allFeatures: [],
    form: {
      featureFlag: undefined,
      value: undefined,
      source: undefined,
    },
  }),
  computed: {
    featuresList() {
      if (!this.features) {
        return []
      }
      return Object.values(this.features)
    },
    allFeatureNames() {
      if (!this.featureMap) {
        return []
      }
      let keys = Array.from(this.featureMap.keys())
      return keys
    },
    accountCode() {
      return this.$route.params.accountId
    },
    featureMap() {
      if (!this.allFeatures) {
        return undefined
      }
      const map = new Map()
      this.allFeatures.forEach(f => {
        map.set(f.name, f)
      })
      return map
    },
    showInternal: {
      get() {
        return this.showDialog
      },
      set(newValue) {
        this.$emit('update-show', newValue)
      },
    },
  },
  methods: {
    ...mapActions({
      setFeatureFlags: 'setFeatureFlags',
    }),
    isFlagType(flagName, type) {
      if (flagName == null || type == null) {
        return false
      }
      const feature = this.getFeature(flagName)
      if (feature && feature.type === type) {
        return true
      }
      return false
    },
    isArrayFlag(flagName) {
      return this.isFlagType(flagName, 'ARRAY')
    },
    isBooleanFlag(flagName) {
      return this.isFlagType(flagName, 'BOOLEAN')
    },
    isStringFlag(flagName) {
      return this.isFlagType(flagName, 'STRING')
    },
    isMapStringStringFlag(flagName) {
      return this.isFlagType(flagName, 'MAP_SS')
    },
    getFeature(flagName) {
      if (this.allFeatures == null || flagName == null) {
        return undefined
      }
      const feature = this.allFeatures.find(f => f.name === flagName)
      return feature
    },

    async getFullFeatureList() {
      const url = `/admin/features`
      try {
        const response = await this.$http.get(url)
        this.allFeatures = response.data
      } catch (ex) {
        console.error(ex)
        this.$error('Fetch all features failed.')
      }
    },
    async getAccountFeatures() {
      try {
        const featuresResponse = await this.$http.get(`/api/accounts/${this.$route.params.accountId}/features`)
        this.setFeatureFlags(featuresResponse.data)
      } catch (ex) {
        console.error(ex)
        this.$error('Getting Account Features')
      }
    },
    async upsertFeature() {
      if (!this.accountCode) {
        this.$error('Must be in an account context')
        return
      }
      const body = { ...this.form }
      await this.updateFeature(body)
    },
    //       { featureFlag, value, source }
    async updateFeature(feature) {
      if (!this.accountCode) {
        this.$error('Must be in an account context')
        return
      }
      try {
        const url = `/admin/features/account/${this.accountCode}`
        await this.$http.post(url, feature)
        await this.getAccountFeatures()
        this.$alert('Success')
      } catch (ex) {
        console.error(ex)
        this.$error('Upsert feature failed.')
      }
    },
    async removeFeatureFlag(flagname) {
      try {
        const url = `/admin/features/account/${this.accountCode}/${flagname}`
        await this.$http.delete(url)
        await this.getAccountFeatures()
      } catch (ex) {
        console.error(ex)
        this.$error('Remove feature failed.')
      }
    },
    editFlag(name) {
      this.form.featureFlag = name
      this.form.value = undefined
      this.form.source = undefined
      if (this.features) {
        const flag = this.features[name]
        if (flag) {
          this.form.value = flag.value
          this.form.source = flag.source
        }
      }
      const el = this.$refs.scrollToMe;
      if (el) {
        el.$el.scrollIntoView({behavior: 'smooth'});
      }
    },
    async flipFeatureFlag(feat) {
      const updatedValue = !feat.value
      const feature = {
        featureFlag: feat.name,
        value: updatedValue,
        source: feat.source,
      }
      await this.updateFeature(feature)
    },
  },
  filters: {
    pretty: function (value) {
      if (!value) return value
      const json = JSON.stringify(value)

      return JSON.stringify(JSON.parse(json), null, 2)
    },
  },
}
</script>
